import { createApiCall } from 'lib/base';

interface CreateStaffAccountBody {}

const CREATE_STAFF_ACCOUNT = 'CREATE_STAFF_ACCOUNT';

export const createStaffAccountApi = createApiCall<
  CreateStaffAccountBody & { payload: any }
>(CREATE_STAFF_ACCOUNT, ({ payload }) => ({
  endpoint: `api/admin/staff-accounts`,
  method: 'POST',
  body: payload,
}));

export default createStaffAccountApi;
